module.exports = __webpack_public_path__ + "img/Unidad7-2.0fd5be2b.png";